
































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Validator } from 'vee-validate';

import Input from '@/shared/components/Inputs/Input.vue';
import Field from '@/shared/components/Field/Field.vue';

@Component({
  components: {
    Input,
    Field,
  },
})
export default class EssencialInformation extends Vue {
  @Prop() private validator: Validator;
  @Prop() private value: any;

  private documentLoading = false;
  private emailLoading = false;
  private showPassword = false;

  private togglePassword() {
    this.showPassword = !this.showPassword;
  }

  private async onDocumentBlur(event: any) {
    this.documentLoading = true;
    await this.validator.validate('document', this.value.document.replace(/\D/g, ''));
    this.documentLoading = false;
  }

  private async onEmailBlur(event: any) {
    this.emailLoading = true;
    await this.validator.validate('email', this.value.email);
    this.emailLoading = false;
  }

  private change(input: string) {
    this.validator.validate(input, (this.$refs[input] as any).value);
  }

  private createValidations() {
    this.validator.attach({
      name: 'name',
      rules: 'required',
    });

    this.validator.attach({
      name: 'document',
      rules: 'required|cpf|userNotExists',
    });

    this.validator.attach({
      name: 'phone',
      rules: 'required|min:15|phoneStartsWithNine',
    });

    this.validator.attach({
      name: 'email',
      rules: 'required|email|userNotExists',
    });

    this.validator.attach({
      name: 'password',
      rules: 'required|min:6',
    });

    this.$emit('update:validator', this.validator);
  }

  private mounted() {
    this.createValidations();
  }
}
